import React from "react";

import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Stack from "react-bootstrap/Stack";

export default function Success({
  title,
  description,
  highlightText,
  onClose,
}) {
  return (
    <Modal.Body className="modal--lg">
      <Stack
        gap={4}
        className="text-center img--round-before img--round-before-lg background-icon-xxl background-icon-success background-icon-success"
      >
        <h4 className="modal-body-heading-title mb-0">{title}</h4>
        {(description || highlightText) && (
          <div>
            {description && <p>{description}</p>}
            {highlightText && (
              <span className="fs-md fs-md-bold text-center">
                {highlightText}
              </span>
            )}
          </div>
        )}
      </Stack>
      <Stack className="btn-group-flex">
        <Button size="lg" onClick={onClose}>
          Close
        </Button>
      </Stack>
    </Modal.Body>
  );
}
